export const validateGroupName = (name: string) => {
  switch (name) {
    case 'empresaIds':
      return 'empresa'
    case 'empresaSelectIds':
      return 'empresa'
    case 'centroCdLojaIds':
      return 'loja'
    case 'centroCdLojaSelectIds':
      return 'loja'
    case 'categoriaCompactaIds':
      return 'categoriaCompacta'
    case 'categoriaCompactaSelectIds':
      return 'categoriaCompacta'
    case 'categoriasIds':
      return 'categoriaCompacta'
    case 'categoriasSelectIds':
      return 'categoriaCompacta'
    case 'categoriaIds':
      return 'categoria'
    case 'categoriaSelectIds':
      return 'categoria'
    case 'anosIds':
      return 'ano'
    case 'anosSelectIds':
      return 'ano'

    case 'gerenteCategoriaIds':
      return 'gerenteCategoria'
    case 'gerenteCategoriaSelectIds':
      return 'gerenteCategoria'

    case 'gerenteProdutoIds':
      return 'gerenteProduto'
    case 'gerenteProdutoSelectIds':
      return 'gerenteProduto'

    case 'mesesIds':
      return 'mes'
    case 'mesesSelectIds':
      return 'mes'
    case 'historicoIds':
      return 'historico'
    case 'historicoSelectIds':
      return 'historico'
    case 'operacaoIds':
      return 'operacao'
    case 'operacaoSelectIds':
      return 'operacao'
    default:
      return null
  }
}
